<template>
    <div>

        <v-snackbar
          v-model="message.status"
          v-bind="message"
          v-for="(message,i) in messages"
          :style="{ 'margin-bottom':calcMargin(i)} "
          :key="i"
        >
          
          <span v-html="message.content"></span>

        </v-snackbar>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default 
{
   name: 'Growler',

   mixins: [],

   components: 
   {

   },

   data: () => ({
    snackbar: true
   }),

   props: {
    
   },

   computed: {

    ...mapGetters({
        messages: 'growler/messages'
    })

   },

   methods:
   {
        calcMargin(i)
        {
            const length = this.messages[i].length,
                  margin = 20 * ( length / 102 - 1 )

            return ( i * (60+margin) ) + 'px'
        },
   },

   mounted()
   {

   }
}
</script>